function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AdminKeyTemplate = require('./adminkey.template');
var AdminKeyUI = /*#__PURE__*/function () {
  function AdminKeyUI(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.saito-container';
    _classCallCheck(this, AdminKeyUI);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.submitting = false;
  }
  return _createClass(AdminKeyUI, [{
    key: "render",
    value: function render() {
      this.app.browser.replaceElementContentBySelector(AdminKeyTemplate(this.mod.publicKey), this.container);
      this.attachEvents();
      this.updateConnection();
    }
  }, {
    key: "updateConnection",
    value: function updateConnection() {
      var btn = document.getElementById('submit-admin-key');
      if (!btn) return;
      var state = this.mod.server_connection.state;
      btn.disabled = this.submitting || state !== 'connected';
      var messages = {
        idle: 'Connecting to the server…',
        configured: 'Connecting to the configured server endpoint…',
        fallback: 'Trying the server at this page’s address…',
        connected: '',
        failed: 'Server connection failed.'
      };
      document.getElementById('admin-connection-status').textContent = messages[state];
      document.getElementById('admin-connection-help').hidden = state !== 'failed';
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var btn = document.getElementById('submit-admin-key');
      if (!btn) {
        return;
      }
      btn.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _document$getElementB;
        var publicKey, showError, tx, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(_this.submitting || _this.mod.server_connection.state !== 'connected')) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              publicKey = (_document$getElementB = document.getElementById('admin-public-key')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value;
              if (_this.app.crypto.isPublicKey(publicKey)) {
                _context.n = 2;
                break;
              }
              salert('Not a valid Saito public key!');
              return _context.a(2);
            case 2:
              _this.submitting = true;
              _this.updateConnection();
              siteMessage('Registering Admin Key...');
              showError = function showError(error) {
                siteMessage('Admin registration failed.', 5000);
                salert(error);
                _this.submitting = false;
                _this.updateConnection();
              };
              _context.p = 3;
              _context.n = 4;
              return _this.app.wallet.createUnsignedTransactionWithDefaultFee(_this.mod.server_publickey);
            case 4:
              tx = _context.v;
              tx.msg = {
                module: 'Admin',
                request: 'set-admin-key',
                key: publicKey
              };
              _context.n = 5;
              return tx.sign();
            case 5:
              if (!(_this.mod.server_connection.state !== 'connected')) {
                _context.n = 6;
                break;
              }
              throw new Error('Server connection lost. Wait for reconnection before trying again.');
            case 6:
              _context.n = 7;
              return _this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                // Transport failures arrive as plain { err } objects, not transactions.
                var res = typeof res_tx.returnMessage === 'function' ? res_tx.returnMessage() : res_tx;
                if (res !== null && res !== void 0 && res.err) {
                  showError(res.err);
                } else {
                  _this.app.wallet.backupWallet();
                  siteMessage('Admin key successfully set, downloaded copy! Reloading page...');
                  reloadWindow(1200);
                }
              }, _this.mod.server_publickey);
            case 7:
              _context.n = 9;
              break;
            case 8:
              _context.p = 8;
              _t = _context.v;
              showError(_t.message || String(_t));
            case 9:
              return _context.a(2);
          }
        }, _callee, null, [[3, 8]]);
      }));
    }
  }]);
}();
module.exports = AdminKeyUI;